"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const QuestionTypes_1 = require("../../Enum/QuestionTypes");
const QuestionAnswerValueTypes_1 = require("../../Enum/QuestionAnswerValueTypes");
const DateSegments_1 = require("../../Enum/DateSegments");
class Question {
    constructor() {
        this.required = false;
        this.options = {};
    }
    getId() {
        return this.id;
    }
    setId(id) {
        this.id = id;
        return this;
    }
    getTitle() {
        return this.title;
    }
    setTitle(value) {
        this.title = value;
        return this;
    }
    getDescription() {
        return this.description;
    }
    setDescription(value) {
        this.description = value;
        return this;
    }
    getType() {
        return this.type;
    }
    setType(value) {
        this.type = value;
        return this;
    }
    getAnswerType() {
        return this.answerType;
    }
    setAnswerType(value) {
        this.answerType = value;
        return this;
    }
    getWeight() {
        return this.weight;
    }
    setWeight(value) {
        this.weight = value;
        return this;
    }
    getAnswerLabel() {
        return this.answerLabel;
    }
    setAnswerLabel(value) {
        this.answerLabel = value;
        return this;
    }
    getOptions() {
        return this.options;
    }
    setOptions(value) {
        this.options = value || {};
        return this;
    }
    getPossibleAnswers() {
        return this.possibleAnswers;
    }
    setPossibleAnswers(value) {
        this.possibleAnswers = value;
        return this;
    }
    getDefaultAnswer() {
        return this.defaultAnswer;
    }
    setDefaultAnswer(value) {
        this.defaultAnswer = value;
        return this;
    }
    isDefaultAnswerOption(answer) {
        const defaults = this.getDefaultAnswer();
        if (defaults === null || defaults === undefined) {
            return false;
        }
        return defaults.indexOf(answer.getValue()) !== -1;
    }
    isValueTypeString() {
        return this.getAnswerType() === QuestionAnswerValueTypes_1.QuestionAnswerValueTypes.STRING;
    }
    isValueTypeNumber() {
        return this.getAnswerType() === QuestionAnswerValueTypes_1.QuestionAnswerValueTypes.NUMBER;
    }
    isValueTypeBoolean() {
        return this.getAnswerType() === QuestionAnswerValueTypes_1.QuestionAnswerValueTypes.BOOLEAN;
    }
    isMultipleSelect() {
        return this.getType() === QuestionTypes_1.QuestionTypes.MULTIPLE_SELECT;
    }
    isValueTypeDate() {
        return this.getAnswerType() === QuestionAnswerValueTypes_1.QuestionAnswerValueTypes.DATE;
    }
    isSingleSelect() {
        return this.getType() === QuestionTypes_1.QuestionTypes.SINGLE_SELECT;
    }
    isTextInput() {
        return this.getType() === QuestionTypes_1.QuestionTypes.TEXT;
    }
    getInputPlaceholder() {
        const placeholder = this.getOptions().placeholder;
        return placeholder !== undefined ? placeholder : null;
    }
    getInputMin() {
        const min = this.getOptions().min;
        return min !== undefined ? min : null;
    }
    getInputMax() {
        const max = this.getOptions().max;
        return max !== undefined ? max : null;
    }
    getInputRegex() {
        const regex = this.getOptions().regex;
        return regex !== undefined ? regex : null;
    }
    getInputPostfix() {
        const postfix = this.getOptions().postfix;
        return postfix !== undefined ? postfix : null;
    }
    getInputPrefix() {
        const prefix = this.getOptions().prefix;
        return prefix !== undefined ? prefix : null;
    }
    isRequired() {
        return this.required;
    }
    setRequired(value) {
        this.required = value;
        return this;
    }
    isDropdown() {
        return this.getOptions().display === "select";
    }
    isRadio() {
        return this.getOptions().display === "radio";
    }
    getDefaultDateSegment(segment) {
        if (this.defaultAnswer) {
            let answer = this.defaultAnswer.toString();
            return answer.split("-")[DateSegments_1.DateSegments[segment]];
        }
        else {
            return "";
        }
    }
    getDependency() {
        if (this.getOptions().depends_on && this.getOptions().appears_on) {
            return {
                field: this.getOptions().depends_on,
                value: this.getOptions().appears_on,
            };
        }
        return null;
    }
    getLastAnswer() {
        return this.getPossibleAnswers().getArray()[this.getPossibleAnswers().getArray().length - 1].getValue();
    }
}
exports.default = Question;
